import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { MemberAddEditAddress } from 'ui/containers/MemberAddEditAddress';
import { memberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';

const _memberSavedAddress = ( props ) => {
    return (
        <div className='ui-member-saved-address'>

            <MemberAddEditAddress
                enableSelection={ true }
                defaultDescription={ props.defaultDescription }
                { ...props }
            />
                
        </div>
    );
};

// set display name
_memberSavedAddress.displayName = 'memberSavedAddress';

// set default props
_memberSavedAddress.defaultProps = {};

// prop types
_memberSavedAddress.propTypes = {};

/********************************* */


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberSavedAddress as MemberSavedAddress } from 'ui/views/widgets/memberSavedAddress';
 *
 * // render
 * <MemberSavedAddress propName='propValue'/>
 */
export const memberSavedAddress = withNetworkState( memberAddEditAddresspreloader, _memberSavedAddress );
